import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "astra-logo",
  "use": "astra-logo-usage",
  "viewBox": "0 0 224.4 81.1",
  "content": "<symbol viewBox=\"0 0 224.4 81.1\" id=\"astra-logo\"><g fill=\"#539ebc\"><path d=\"M96 55.2l-1.9-6.7h-7.6l-1.9 6.7h-6.9l7.5-26.7h10.4l7.5 26.7H96zm-4.8-18.7c-.3-1.3-.6-2.7-.8-4.1h-.3c-.2 1.4-.5 2.8-.8 4.1l-1.9 7.1h5.8l-1.9-7.1zM114.5 55.8c-3.6 0-7.3-.4-9-.9v-4.4c2.3.2 4.8.4 8.3.4s4.3-.9 4.3-2.9-.6-2.1-3.2-3.2l-3.9-1.7c-3.8-1.6-6.2-3.5-6.2-8s3.7-7.4 10.4-7.4 6.6.5 8.2.9v4.3c-2.5-.2-4.8-.4-7.8-.4s-4.2.5-4.2 2.4.6 1.9 3 2.9l3.8 1.5c4.5 1.8 6.6 4 6.6 8.2s-3.8 8.1-10.3 8.1zM141.8 33.3v21.8H135V33.3h-7.7v-4.9h22.2v4.9h-7.7zM169.1 55.2l-5.5-9.5h-4v9.5h-6.5V28.5c2.7-.1 5.3-.3 8.6-.3 6.7 0 12.4 1.3 12.4 8.6v.3c0 4-1.6 6.1-4.2 7.4l6 10.8h-6.8zm-1.5-18.3c0-3-1.7-3.7-5.7-3.7h-2.4V41h2.4c4 0 5.6-.9 5.6-3.9v-.3zM195.4 55.2l-1.9-6.7h-7.6l-1.9 6.7h-6.9l7.5-26.7H195l7.5 26.7h-7.1zm-4.7-18.7c-.3-1.3-.6-2.7-.8-4.1h-.3c-.2 1.4-.5 2.8-.8 4.1l-1.9 7.1h5.8l-1.9-7.1z\" /></g><path fill=\"#539ebc\" d=\"M43.8 26.3l29.4-13.6-13.5 29.4 13.5 29.4L43.8 58 14.4 71.5l13.5-29.4-13.5-29.4 29.4 13.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/astra-logo.svg
// module id = FLZ4
// module chunks = 1